import React from "react";

const EasilyManage = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2565_1829)">
      <path
        d="M12.0009 19.0002H5.00092C4.47048 19.0002 3.96177 18.7895 3.5867 18.4145C3.21163 18.0394 3.00092 17.5307 3.00092 17.0002V7.00024C3.00092 6.46981 3.21163 5.9611 3.5867 5.58603C3.96177 5.21096 4.47048 5.00024 5.00092 5.00024H19.0009C19.5313 5.00024 20.0401 5.21096 20.4151 5.58603C20.7902 5.9611 21.0009 6.46981 21.0009 7.00024V11.2502"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00058 7.99976H6.01058"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00076 7.99976H9.01076"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5131 19.7429C15.5406 19.8661 15.605 19.978 15.6978 20.0635C15.7906 20.149 15.9073 20.2041 16.0323 20.2214C16.1573 20.2387 16.2846 20.2173 16.3972 20.1602C16.5097 20.103 16.6021 20.0129 16.6619 19.9017L17.7394 18.307L20.2694 20.837C20.3205 20.8881 20.3812 20.9286 20.4479 20.9563C20.5147 20.9839 20.5862 20.9981 20.6585 20.9981C20.7307 20.9981 20.8022 20.9839 20.869 20.9563C20.9357 20.9286 20.9964 20.8881 21.0475 20.837L21.5873 20.2972C21.6384 20.2461 21.6789 20.1855 21.7065 20.1187C21.7342 20.052 21.7484 19.9804 21.7484 19.9082C21.7484 19.8359 21.7342 19.7644 21.7065 19.6976C21.6789 19.6309 21.6384 19.5703 21.5873 19.5192L19.0573 16.9892L20.6623 15.9116C20.7734 15.8517 20.8636 15.7593 20.9207 15.6468C20.9778 15.5342 20.9991 15.4069 20.9818 15.2819C20.9644 15.1569 20.9093 15.0401 20.8237 14.9474C20.7381 14.8546 20.6262 14.7902 20.503 14.7629L13.5003 12.75L15.5131 19.7429Z"
        stroke="#6F43E7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2565_1829">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EasilyManage;
